import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { PopoutButton } from "@/Common/Components/Buttons/PopoutButton";

import TrashIcon from "@/Globals/_images/trash3.svg";
import ZoomInIcon from "@/Globals/_images/zoom-in.svg";
import ZoomOutIcon from "@/Globals/_images/zoom-out.svg";

interface PdfViewerViewToolbarProps {
    onZoomLevelChange: (zoomChange: number) => void;
    onTrashDocument?: () => void;
    onClearSelection?: () => void;
    onSelectAllSelection?: () => void;
    onPopoutPdf?: () => void;
    selectedPageNumbers?: number[];
    isReadOnly?: boolean;
    isDeletable?: boolean;
    shouldShowPopout?: boolean;
}

class PdfViewerViewToolbar extends BaseReactComponent<PdfViewerViewToolbarProps> {
    public render(): JSX.Element {
        return (
            <div className="pdf-viewer-view-toolbar toolbar" style={this.props?.isReadOnly ? { zIndex: 1 } : {}}>
                {(!this.props?.isReadOnly && this.props.isDeletable) &&
                    <button onClick={() => this.props.onTrashDocument()} className="btn-danger"><TrashIcon /></button>
                }
                <button onClick={() => this.props.onZoomLevelChange(-1)}>
                    <ZoomOutIcon />
                </button>
                <button onClick={() => this.props.onZoomLevelChange(1)}>
                    <ZoomInIcon />
                </button>
                {this.props.shouldShowPopout && (
                    <PopoutButton
                        onPopoutClick={() => this.props.onPopoutPdf?.()}
                    />
                )}

                {!this.props?.isReadOnly && (
                    <div className="toolbar-page-selection">
                        <label>{cacheStore.GetString("SelectionsLabel")}</label>
                        <div>
                            {this.props.selectedPageNumbers.length} pages ({this.props.selectedPageNumbers.join(", ")})
                            {this.props.selectedPageNumbers.length > 0 &&
                                <a onClick={() => this.props.onClearSelection()}>{cacheStore.GetString("ClearAllLabel")}</a>
                            }
                            {this.props.selectedPageNumbers.length === 0 &&
                                <a onClick={() => this.props.onSelectAllSelection()}>{cacheStore.GetString("SelectAllLabel")}</a>
                            }
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export { PdfViewerViewToolbar };
